import { render, staticRenderFns } from "./expertDatabaseInfo.vue?vue&type=template&id=474eba48&scoped=true"
import script from "./expertDatabaseInfo.vue?vue&type=script&lang=js"
export * from "./expertDatabaseInfo.vue?vue&type=script&lang=js"
import style0 from "./expertDatabaseInfo.vue?vue&type=style&index=0&id=474eba48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474eba48",
  null
  
)

export default component.exports